<script>
    import Page from './Page/Page.svelte';
    import Banner from '@itslearning/prometheus/assets/feedback/Banner/v1/Banner.svelte';
    import LoadingSpinner from '@itslearning/prometheus/assets/nodes/LoadingSpinner/v1/LoadingSpinner.svelte';
    import QuestionResult from './QuestionResult/QuestionResult.svelte';
    import MatrixQuestion from './MatrixQuestion/MatrixQuestion.svelte';
    import MultipleChoiceQuestion from './MultipleChoiceQuestion/MultipleChoiceQuestion.svelte';
    import MultipleResponseQuestion from './MultipleResponseQuestion/MultipleResponseQuestion.svelte';
    import RelativeDate from './RelativeDate/RelativeDate.svelte';
    import YesNoQuestion from './YesNoQuestion/YesNoQuestion.svelte';
    import {navigateToResultsPage, navigateToViewSurveyPage} from '../navigation';
    import {questions, navigation, permissions, allAnswers, use12HTimeFormat, locale, olsonTimeZoneId, i18nRelativeDate} from '../stores';
    import {getAnswer} from '../api'; 
    import {txt} from '../i18n/i18n';
    import {Answer} from '../models/Answer';
    import {QuestionAnswer} from '../models/QuestionAnswer';
    import {onMount} from 'svelte';  

    $: answerId = $navigation.answerId;
    $: answer = $allAnswers.find(a => a.answerId === answerId);
    $: showErrorMessage = false;
    let message = { text: txt('Unknown_error'), type: 'warning' };

    onMount(async () => {
        if (!answer) {
            try {
                await getAnswer(answerId).then(
                    result => {
                        allAnswers.update(currentAnswers => {currentAnswers = [...currentAnswers, new Answer(result)]; return currentAnswers;});
                        showErrorMessage = false;
                    }
                );
            } catch {
                showErrorMessage = true;
            }
        }
    });

    function getQuestionAnswer(answer, questionId) {
        if (!answer){
            return new QuestionAnswer({});
        }

        const qa = answer.questionAnswers.find(a => a.questionId === questionId);
        return qa ? qa : new QuestionAnswer({});
    }

    function shouldNavigateToResultPage() {
        return $permissions.canEvaluate && $navigation.viewTabId == 'tabResults';
    }
</script>

<Page title={txt('Survey_title')} headingPosition="insideContentBlock" focusHeading={true}
    backLinkHref={shouldNavigateToResultPage() ? '#show-result' : '#view'}
    backLinkText={shouldNavigateToResultPage() ? txt('Back_to_responses') : txt('Back_to_survey_details')}
    on:click={shouldNavigateToResultPage() ?  navigateToResultsPage : navigateToViewSurveyPage} >

    {#if !answer}
        <div class="spinner">
            <LoadingSpinner size="large" visible={!showErrorMessage} />
        </div>
        <Banner visible={showErrorMessage} close={txt('Close')} type={message.type} text={message.text}></Banner>
    {:else}
        <div>
            <RelativeDate date={new Date(answer.completed)} 
                twelveHourFormat={use12HTimeFormat} 
                timeZone={olsonTimeZoneId} 
                locale={locale} 
                i18n={i18nRelativeDate} />
        </div>
        
        {#each $questions as question, i}
            <QuestionResult {question} number={i + 1}>
                {#if question.type === 'Open'}
                    <div class="user-content">{txt('Open_answer_heading') + ': ' + getQuestionAnswer(answer, question.questionId).text}</div>
                {:else if question.type === 'MultipleChoice' && question.maxAlternativesToSelect === 1}
                    <MultipleChoiceQuestion {question} questionAnswer={getQuestionAnswer(answer, question.questionId)} readonly={true}></MultipleChoiceQuestion>
                {:else if question.type === 'MultipleChoice'}
                    <MultipleResponseQuestion {question} questionAnswer={getQuestionAnswer(answer, question.questionId)} readonly={true}></MultipleResponseQuestion>
                {:else if question.type === 'YesNo'}
                    <YesNoQuestion {question} questionAnswer={getQuestionAnswer(answer, question.questionId)} readonly={true}></YesNoQuestion>
                {:else if question.type === 'Matrix'}
                    <MatrixQuestion {question} questionAnswer={getQuestionAnswer(answer, question.questionId)} readonly={true}></MatrixQuestion>
                {/if}
            </QuestionResult>
        {/each}
    {/if}
</Page>
